import React, { Component } from "react";
import { withLocalize } from "react-localize-redux";
import { ContentContainer, SpinLoading } from "../../styles/BasicStyles";
import TextInput from "../../components/inputs/TextInput";
import { TranslateFromObject } from "../../infra/services/translations/AvailableTranslations";
import { GetFaqs } from "../../infra/requests/FaqRequests";
import {
  Title,
  SearchSection,
  CategorySection,
  CategoryHeader,
  CategoryTitle,
  CategoryToggle,
  FaqList,
  FaqItem,
  FaqQuestion,
  FaqQuestionText,
  FaqToggle,
  FaqAnswer,
  NoResults
} from "./FaqsStyles";

class FaqsPage extends Component {
  state = {
    ready: false,
    loading: false,
    search: "",
    categories: [],
    openFaq: null,
    // As categorias começam abertas; guardam-se as que os noivos fecharam.
    closedCategories: []
  };

  componentDidMount() {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    document.body.style.overflowY = "auto";

    this.getFaqs();
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  getFaqs = async () => {
    const { search } = this.state;
    this.setState({ loading: true });

    const { data, success } = await GetFaqs(search);

    this.setState({
      categories: success && Array.isArray(data) ? data : [],
      ready: true,
      loading: false,
      openFaq: null,
      closedCategories: []
    });
  };

  onSearchChange = event => {
    const search = event.target.value;

    this.setState({ search }, () => {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(this.getFaqs, 800);
    });
  };

  toggleFaq = id => {
    this.setState(({ openFaq }) => ({ openFaq: openFaq === id ? null : id }));
  };

  toggleCategory = id => {
    this.setState(({ closedCategories }) => ({
      closedCategories: closedCategories.includes(id)
        ? closedCategories.filter(item => item !== id)
        : [...closedCategories, id]
    }));
  };

  render() {
    const { translate, activeLanguage } = this.props;
    const {
      ready,
      loading,
      search,
      categories,
      openFaq,
      closedCategories
    } = this.state;

    if (!ready) return <SpinLoading />;

    return (
      <ContentContainer>
        <Title>{translate("FAQS")}</Title>
        <SearchSection>
          <TextInput
            type="text"
            label={translate("FAQS_SEARCH")}
            input={{ value: search, onChange: this.onSearchChange }}
            meta={{}}
          />
        </SearchSection>
        {loading ? (
          <SpinLoading />
        ) : categories.length === 0 ? (
          <NoResults>{translate("NO_RESULTS")}</NoResults>
        ) : (
          categories.map(category => {
            const categoryOpen = !closedCategories.includes(category._id);

            return (
              <CategorySection key={category._id}>
                <CategoryHeader
                  onClick={() => this.toggleCategory(category._id)}>
                  <CategoryTitle>
                    {TranslateFromObject(category.name, activeLanguage?.code)}
                  </CategoryTitle>
                  <CategoryToggle open={categoryOpen ? 1 : 0} />
                </CategoryHeader>
                <FaqList open={categoryOpen ? 1 : 0}>
                  {category.faqs.map(faq => {
                    const faqOpen = openFaq === faq._id;

                    return (
                      <FaqItem key={faq._id}>
                        <FaqQuestion
                          open={faqOpen ? 1 : 0}
                          onClick={() => this.toggleFaq(faq._id)}>
                          <FaqQuestionText>
                            {TranslateFromObject(
                              faq.question,
                              activeLanguage?.code
                            )}
                          </FaqQuestionText>
                          <FaqToggle open={faqOpen ? 1 : 0} />
                        </FaqQuestion>
                        <FaqAnswer
                          open={faqOpen ? 1 : 0}
                          dangerouslySetInnerHTML={{
                            __html: TranslateFromObject(
                              faq.answer,
                              activeLanguage?.code
                            )
                          }}
                        />
                      </FaqItem>
                    );
                  })}
                </FaqList>
              </CategorySection>
            );
          })
        )}
      </ContentContainer>
    );
  }
}

export default withLocalize(FaqsPage);
